import { initContract } from '@ts-rest/core';
import { z } from 'zod';
////////////////////////////////////////////////////////////////////////////////
// getSyncStatus
////////////////////////////////////////////////////////////////////////////////
export const GetSyncStatusResponse = z.union([z.number().min(0).max(100), z.null()]);
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const commonContract = c.router({
    getSyncStatus: {
        method: 'GET',
        path: '/get-sync-status',
        responses: {
            200: GetSyncStatusResponse,
        },
    },
}, {
    strictStatusCodes: true,
    pathPrefix: '/common',
});
